// Module Import
//---------------------------------
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {brandIvory, brandOrange, brandSoftGrey} from '../../../assets/consts/color'
import { secondaryFont } from '../../../assets/consts/fonts'
import Image from "../images/images";
import ArrowIcon from '../../../assets/images/icon_simplified_arrow.svg'

// Component Import
//---------------------------------

// Styled Component Declarations
//---------------------------------
const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
 
  .select-padding-top {
    padding-bottom: 16px;
  }
  
  .input-wrapper {
    position: relative;
    background-color: ${brandIvory};

      font-family: ${secondaryFont};
      font-size: 20px;
      font-style: normal;
      font-weight: 300;
      line-height: 100%; /* 20px */
      width: 100%;
      display: flex;
      align-items: center;
      color: ${brandSoftGrey};
      
      .prefix {
          padding-left: 16px;
          flex-shrink: 0;
      }
    
    &:after {
      content: "";
      position: absolute;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
      background-image: url(${ArrowIcon});
      z-index: 1;
      background-repeat: no-repeat;
      height: 8px;
      width: 12px;
    }
  }
`

const FieldLabel = styled.label`
  color: ${brandSoftGrey};
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px; /* 87.5% */
  height: 0;
  visibility: hidden;
  width: 100%;'
`

export const InputField = styled.select`
  display: flex;
  padding: 24px 16px;
  padding-right: 34px;
  background-color: transparent;
  z-index: 2;
  align-self: stretch;
  border: 0;
  transition: all 0.25s;
  color: ${brandSoftGrey};
  position: relative;  

  -webkit-appearance: none;
  -moz-appearance: none;
    
  font-family: ${secondaryFont};
  font-size: 20px;
  font-style: normal;
  font-weight: 300;
  line-height: 100%; /* 20px */
  width: 100%;

  resize: none;

  &:focus {
    outline: none;
  }

`

// Component Export
//---------------------------------
export default function SelectField({
  labelText,
  labelFor,
  placeholderText,
  fieldId,
  fieldName,
  options,
  prefix,
  ...prop
}) {
  return (
    <FieldWrapper>
      <FieldLabel htmlFor={labelFor}>{labelText}</FieldLabel>
      <div className="select-padding-top" />
        <div className="input-wrapper">
          {prefix && <span className="prefix">{prefix}</span>}
          <InputField id={fieldId} name={fieldName} placeholder={placeholderText} {...prop}>
            {options.map((option) => (
              <option
                disabled={option?.disabled}
                key={option.value}
                value={option.value}
                selected={prop.value === option.value}
              >
                {option.label}
              </option>
            ))}
          </InputField>
        </div>
      <div />
    </FieldWrapper>
  )
}

SelectField.propTypes = {
  labelText: PropTypes.string.isRequired,
  labelFor: PropTypes.string.isRequired,
  placeholderText: PropTypes.string.isRequired,
  fieldId: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
}
